import React, { Component, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';

function GoalFieldList({
  directRecords,
  disableAddButton,
  disableSaveButtons,
  disableDeleteButtons,
  planPrompt,
  readOnly,
  label,
  keyPrefix,
  addLabel,
  childProps,
  onSave,
  RecordComponent,
  onRemove,
  onAddNewRecord,
}) {
  const [recordList, setRecordList] = useState([]);
  const [removeIndex, setRemoveIndex] = useState(-1);
  const [shouldExpandNewRecords, setShouldExpandNewRecords] = useState(false);

  useEffect(() => {
    setRecordList(directRecords);
  }, [directRecords]);

  const removeRecord = (index) => {
    const recordToDelete = recordList[index];
    recordList.splice(index, 1);
    setRecordList(recordList);
    if (recordToDelete.id) {
      onRemove(recordToDelete);
    }
    setRemoveIndex(-1);
  };

  const getRemoveButton = (index) => {
    const button = (
      <a
        role="presentation"
        className="remove"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setRemoveIndex(index);
        }}
      >
        <FontAwesome icon="remove" />
        <span>Delete</span>
      </a>
    );

    const prompt = (
      <div className="remove">
        <span className="pad-right">Are you sure you want to delete this?</span>
        <a
          role="presentation"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            removeRecord(index);
          }}
        >
          <span className="pad-right color-facet-green">Yes</span>
        </a>
        <a
          role="presentation"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setRemoveIndex(-1);
          }}
        >
          <span className="color-facet-red">No</span>
        </a>
      </div>
    );
    return (
      <span className="questionnaire-input">
        {removeIndex === index ? prompt : button}
      </span>
    );
  };

  return (
    <div className="questionnaire-field-list">
      {label !== '' && (
        <div className="questionnaire-field-list-header">
          <span className="field-list-label">{label}</span>
        </div>
      )}
      {recordList && recordList.length > 0 && (
        <div className="questionnaire-field-list-clones">
          {recordList.map((record, index) => (
            <React.Fragment key={keyPrefix + record.id}>
              <RecordComponent
                {...childProps}
                record={record}
                id={record.id}
                onSave={onSave}
                removeButton={getRemoveButton(index)}
                defaultExpanded={
                  shouldExpandNewRecords && index === recordList.length - 1
                }
                disableSaveButtons={disableSaveButtons}
                disableDeleteButtons={disableDeleteButtons}
                planPrompt={planPrompt}
                readOnly={readOnly}
              />
            </React.Fragment>
          ))}
        </div>
      )}
      {!disableAddButton && (
        <div className="questionnaire-field-list-footer">
          <span
            role="presentation"
            onClick={() => {
              onAddNewRecord();
              setShouldExpandNewRecords(true);
            }}
            className="field-list-add-label"
          >
            <FontAwesome icon="plus-circle" />
            <button type="button" test="goal-field-action">
              <span>{addLabel}</span>
            </button>
          </span>
        </div>
      )}
    </div>
  );
}

GoalFieldList.propTypes = {
  label: PropTypes.string,
  addLabel: PropTypes.string,
  keyPrefix: PropTypes.string.isRequired,
  childProps: PropTypes.instanceOf(Object),
  directRecords: PropTypes.array,
  disableAddButton: PropTypes.bool,
  disableSaveButtons: PropTypes.bool,
  disableDeleteButtons: PropTypes.bool,
  planPrompt: PropTypes.string,
  readOnly: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  RecordComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.instanceOf(Component),
  ]).isRequired,
  onAddNewRecord: PropTypes.func.isRequired,
};

GoalFieldList.defaultProps = {
  label: '',
  addLabel: '',
  childProps: {},
  directRecords: [],
  disableAddButton: false,
  disableSaveButtons: false,
  disableDeleteButtons: false,
  planPrompt: '',
  readOnly: false,
};

export default GoalFieldList;
